export { T as Curriculum } from "./Curriculum";
